// Shared avatar color palette and helper for deterministic per-UUID colors

export const AVATAR_COLORS = [
  { backgroundColor: '#44C0D4', color: '#FFFFFF' },
  { backgroundColor: '#4A6BDF', color: '#FFFFFF' },
  { backgroundColor: '#F15185', color: '#FFFFFF' },
  { backgroundColor: '#FDD019', color: 'rgba(0, 0, 0, 0.5)' },
  { backgroundColor: '#FEAE35', color: 'rgba(0, 0, 0, 0.5)' },
  { backgroundColor: '#4ED293', color: '#FFFFFF' },
  { backgroundColor: '#A56BEE', color: '#FFFFFF' },
  { backgroundColor: '#EF4A4A', color: '#FFFFFF' },
] as const;

type AvatarColor = (typeof AVATAR_COLORS)[number];

export function getAvatarColor(uuid: string): AvatarColor {
  if (!uuid) return AVATAR_COLORS[0];
  const colorIndex = uuid.charCodeAt(0) % AVATAR_COLORS.length;
  return AVATAR_COLORS[colorIndex];
}


